import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import AmateurFilmItem from "../amateurfilms/AmateurFilmItem";
import 'sass/list/AmateurFilmList.scss';

import {openAmateurFilm} from 'reducers/amateurFilm';

class AmateurFilmList extends Component {
    render() {
        let {amateurFilms, singleRow = false, ...restProps} = this.props;

        return (
            <div className={'amateur-film-list ui-responsive-grid ' + (singleRow ? 'single-row' : '')}>
                {amateurFilms.map((amateurFilm, index, amateurFilms) =>
                    <div key={index}>
                        <AmateurFilmItem amateurFilm={amateurFilm} amateurFilms={amateurFilms} {...restProps}/>
                    </div>
                )}
            </div>
        )
    }
}

AmateurFilmList.propTypes = {
    amateurFilms: PropTypes.array,
    singleRow: PropTypes.bool,
    showAuthor: PropTypes.bool,
    showDate: PropTypes.bool,
    showState: PropTypes.bool,
};

export default connect(state => ({ currentUser: state.currentUser }), { openAmateurFilm })(AmateurFilmList);




// WEBPACK FOOTER //
// ./src/components/list/AmateurFilmList.js